import { InputSkeleton } from '@/_components';
import { CardContainer, FormLayout } from '@/_containers';

export default function Loading() {
  return (
    <CardContainer>
      <FormLayout>
        <InputSkeleton className="col-span-12" />
        <InputSkeleton className="col-span-12" />
      </FormLayout>
    </CardContainer>
  );
}
